// WO-03 item 5 — render a UTC instant in a SPECIFIC IANA timezone (the tender's
// / article's own country), never the reader's browser. A Saudi deadline stored
// as 2026-10-31T21:00:00Z must read "1 November 2026" for a reader in Madrid AND
// in Riyadh. One unambiguous long form in both English and Arabic; never a
// numeric date like 01/11/2026, which means two different days in Europe vs the
// Gulf. The timezone string comes from the API (single source of truth:
// scrapers/base.COUNTRY_TZ), so this file never keeps its own copy of it.

// WO-11 second line of defence: a bare ISO string with NO zone
// ("2026-10-31T21:00:00") is a UTC instant in this product, but new Date()
// would read it as the reader's LOCAL time and shift the day. Mark it UTC
// before parsing. Strings that already carry Z or ±HH:MM are left untouched.
// (The API is the authoritative fix; this guards any value that slips through.)
function _asInstant(input) {
  if (typeof input === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(\.\d+)?$/.test(input)) {
    return new Date(input + 'Z');
  }
  return new Date(input);
}

export function formatDateInTZ(input, timeZone, language = 'en') {
  if (!input) return '';
  const date = _asInstant(input);
  if (isNaN(date.getTime())) return '';
  const locale = language === 'ar' ? 'ar' : 'en-GB';
  const opts = { day: 'numeric', month: 'long', year: 'numeric' };
  try {
    return new Intl.DateTimeFormat(locale, { ...opts, timeZone: timeZone || 'UTC' }).format(date);
  } catch {
    return new Intl.DateTimeFormat(locale, opts).format(date);
  }
}

// The calendar day (as seen in `timeZone`) of an instant, expressed as a UTC
// midnight so day differences are clean whole numbers regardless of offset.
function _dayInTZ(date, timeZone) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    year: 'numeric', month: '2-digit', day: '2-digit', timeZone: timeZone || 'UTC',
  }).formatToParts(date).reduce((acc, p) => { acc[p.type] = p.value; return acc; }, {});
  return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
}

// Whole days from "today" to the instant, both measured in `timeZone`.
// Positive = future, negative = past, 0 = today.
export function daysLeftInTZ(input, timeZone) {
  if (!input) return null;
  const date = _asInstant(input);
  if (isNaN(date.getTime())) return null;
  try {
    const target = _dayInTZ(date, timeZone);
    const today = _dayInTZ(new Date(), timeZone);
    return Math.round((target - today) / 86400000);
  } catch {
    return null;
  }
}
